import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

import { TooltipModule } from 'primeng/tooltip';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import { SharedModule } from 'app/modules/settings/shared.module';

import { PartsPricingComponent } from './parts-pricing.component';
import { PriceMatrixItemComponent } from './components/price-matrix-item/price-matrix-item.component';
import { PartPricingRoutingModule } from './parts-pricing-routing.module';
import { PartsPricingDialogComponent } from './parts-pricing-dialog/parts-pricing-dialog.component';
import { CatalogItemPricingDialogComponent } from './components/update-catalog-item-pricing-dialog/update-catalog-item-pricing-dialog.component';
import { PartsPricingCatalogComponent } from './components/catalog-pricing-list/catalog-pricing-list.component';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';

@NgModule({
  imports: [CommonModule, PartPricingRoutingModule,
    SharedModule, NgxMaskDirective, NgxMaskPipe, TooltipModule, TableModule,
    PaginatorModule,
    CheckboxModule],
    
  declarations: [PartsPricingComponent,
    PriceMatrixItemComponent, PartsPricingDialogComponent,
    CatalogItemPricingDialogComponent, PartsPricingCatalogComponent],
    exports: [PartsPricingDialogComponent],
  providers: [DialogService, CurrencyPipe, DynamicDialogRef, DynamicDialogConfig],
})
export class PartPricingModule { }
